import Component from '@glimmer/component';

export default class MwBadge extends Component {

  user = {
    badges: {
      verified: true,
      premium: true,
      level3: true,
    }
  };
}
